import React from 'react';
import { Box, styled } from '@mui/material';

import Typography from '../Typography/Typography';

export default function TabBody({
  children,
  isFullWidth = false,
  tabBodyWidth = 400,
  title,
  titleEndAdornment,
}: {
  children: React.ReactNode;
  isFullWidth?: boolean;
  tabBodyWidth?: number;
  title?: string;
  titleEndAdornment?: React.ReactNode;
}) {
  return (
    <Container tabBodyWidth={tabBodyWidth} isFullWidth={isFullWidth}>
      {title && (
        <Box
          marginBottom='24px'
          display='flex'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography variant='font24'>{title}</Typography>
          {titleEndAdornment}
        </Box>
      )}
      {children}
    </Container>
  );
}

const Container = styled('div', {
  shouldForwardProp: propName =>
    !['tabBodyWidth', 'isFullWidth'].includes(propName as string),
})<{ isFullWidth: boolean; tabBodyWidth: number }>`
  background-color: ${props => props.theme.palette.colors.white};
  border-right: 1px solid ${({ theme }) => theme.palette.colors.slate[100]};
  box-sizing: border-box;
  padding: ${props => (props.isFullWidth ? '0px' : ' 24px')};
  display: flex;
  flex-direction: column;
  width: ${props => (props.isFullWidth ? '100%' : `${props.tabBodyWidth}px`)};
  overflow-y: auto;
`;
